module.exports = __webpack_public_path__ + "static/img/11wr.c383dbe4.webp";